module.exports = __webpack_public_path__ + "static/media/BankTransfer.9ecf2fc9.svg";